import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import { ReviewLoadMore as GenericReviewLoadMore } from '@westwing/ui-kit/Review';
import { StyledReviewContent } from './Review';
import GenericHeading from '@ids/components/Typography/Heading';

export const ReviewsSection = styled.section`
    padding: 0 min(5vw, 40px);
    min-height: 950px;

    ${forTablet`
        min-height: 620px;
    `}
`;

export const Reviews = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 325px;
    margin-bottom: 30px;

    ${forTablet`
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0 60px;
    `}

    & > div:first-child {
        ${StyledReviewContent} {
            border-top: 0;
        }
    }

    ${forTablet`
        & > div:nth-child(-n + 2) {
            ${StyledReviewContent} {
                border-top: 0;
            }
        }
    `}
`;

export const Heading = styled(GenericHeading)`
    text-align: center;
    margin: 0 auto 40px;
    width: min(660px, 100%);
`;

export const ReviewLoadMore = styled(GenericReviewLoadMore)`
    margin-bottom: 40px;
    text-align: center;
`;

export const ReviewSkeleton = styled.div`
    cursor: progress;
`;

export const ReviewSkeletonItem = styled.div`
    position: relative;
    height: 136px;
    background: ${({ theme }) => theme.colors.skeleton01};
    margin: 25px 0;

    &:nth-child(-n + 3) {
        &:after {
            content: '';
            width: 100%;
            height: 1px;
            background: ${({ theme }) => theme.colors.charcoal20};
            position: absolute;
            bottom: -25px;
        }
    }

    ${forTablet`        
        &:nth-child(-n + 2) {
                &:after {
                    content: '';
                    width: 100%;
                    height: 1px;
                    background: ${({ theme }) => theme.colors.charcoal20};
                    position: absolute;
                    bottom: -25px;
                }
            }

            &:nth-child(3) {
                &:after {
                    content: none;
                }
            }
        `}
`;
